import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Box, Hr, Text, Flex } from 'core/ui/atoms';
import Money from 'core/api/Money';

const BillingSummary = ({ billingSummary }) => {
  const {
    addonsTotalAmount,
    creditsTotalAmount,
    finalAmount,
    swapsTotalAmount,
  } = billingSummary || {};

  // eslint-disable-next-line no-console
  console.log('creditsTotalAmount',creditsTotalAmount);

  const creditAmount = creditsTotalAmount?.amount && { __typename: 'Money', amount: -creditsTotalAmount?.amount };

  const billItem = (label, amount) => (
    <BillContainer>
      <BillItemText>{label}</BillItemText>
      <BillItemText>{Money(amount).toFormat('$0,0') || 0}</BillItemText>
    </BillContainer>
  );

  return (
    <Box>
      <HeaderText>Check Out</HeaderText>
      {billItem('Meal Edits', swapsTotalAmount)}
      {billItem('Add-Ons', addonsTotalAmount)}
      {billItem('Credit', creditAmount)}
      <Hr />
      <TotalContainer>
        <BillTotal>Total Amount</BillTotal>
        <BillTotal>{Money(finalAmount).toFormat('$0,0') || 0}</BillTotal>
      </TotalContainer>
    </Box>
  );
};

BillingSummary.propTypes = {
  billingSummary: PropTypes.any,
};

const HeaderText = styled(Text)`
  font-size: 22px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  color: ${(p) => p.theme.colors.primaryV2};
  font-family: ${({ theme }) => theme.typography.familyLarken};
`;

const BillContainer = styled(Flex)`
  justify-content: space-between;
  padding: 0 15px 0 15px;
  width: 100%;
`;

const TotalContainer = styled(Flex)`
  justify-content: space-between;
  padding: 0 15px 0 15px;
  width: 100%;
  margin-top: 16px;
`;

const BillItemText = styled(Text)`
  margin: 0;
  line-height: 22px;
  font-size: 12px;
  color: ${(p) => p.theme.colors.primaryV2};
  font-family: ${({ theme }) => theme.typography.familyPoppins};
`;

const BillTotal = styled(Text)`
  margin: 0;
  line-height: 125%;
  font-size: 16px;
  color: ${(p) => p.theme.colors.primaryV2};
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  font-weight: 500;
`;

export default BillingSummary;
